import lozad from 'lozad'
import { runFunctions } from './_functions'
import { runBlocks } from './_blocks'

const { $ } = window
const $body = $(document.body)

export default {
	init() {
		const observer = lozad('img')
		observer.observe()
		$('.hero img').attr('loading', 'eager')

		runFunctions()
		runBlocks()
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})
	},
}
